import { $api } from '@/shared/api/axiosInstance';

type ResponseType = {
    code: number;
    data: {
        errorMessage: string;
        orderId: string;
        formUrl: string;
    };
    errors: null;
    exception: null;
};

export const checkPayment = async (id: string | undefined) => {
    const { data } = await $api.post<ResponseType>(
        `/api/v1/policy/acquiring/check-status`,
        {},
        {
            headers: {
                'X-Guid': id,
            },
        }
    );

    return data;
};
